/*
 * @Author: 
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2023-12-27 13:46:10
 * @Description: 
 */
import {cn, en} from './locales/portal.js';

function useTranslation() {
    const { locale } = useI18n();
    switch (locale.value) {
        case 'cn':
            return cn;
        default:
            return en;
    }
}
export default useTranslation;

